import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'

type Refresh = () => void

interface EmiteItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingEmitItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmEmit: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenEmitModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setWasEmitted: React.Dispatch<React.SetStateAction<object>> | undefined
  translate: any
}

export const emitItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setHashItemReserve,
  setLoadingEmitItem,
  setNameReserve,
  setConfirmEmit,
  setOpenEmitModal,
  setWasEmitted,
  translate,
}: EmiteItemReservationParams): Promise<void> => {
  try {
    setLoadingEmitItem(true)
    setOpenEmitModal && setOpenEmitModal(false)
    const response = await itemServices.emit_item(hashItemReserve)
    setWasEmitted &&
      setWasEmitted((prev) => ({
        ...prev,
        [hashItemReserve]: true,
      }))
    if (response) {
      notify('ra.notification.emit_item_reserve_success', {
        type: 'success',
        messageArgs: { reserve: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmEmit && setConfirmEmit(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmEmit && setConfirmEmit(false)
    setLoadingEmitItem(false)
    notify('ra.notification.emit_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
  } catch (error: any) {
    const error_reason =  error?.response?.data?.detail ? translate(`ra.backend_error.${error?.response?.data?.detail}`) : ''
    notify('ra.notification.emit_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve, reason: error_reason },
    })
    setOpenEmitModal && setOpenEmitModal(false)
    setNameReserve('')
    setHashItemReserve('')
    setLoadingEmitItem(false)
    setConfirmEmit && setConfirmEmit(false)
  } finally {
    customAwait([refresh])
  }
}
